import {styledByTheme} from '../../../../themes/architecture/styled-by-theme';
import {SwiperWrapperDefaultBox} from './swiper-wrapper.default.box';
import {SwiperWrapperCasino777Box} from './swiper-wrapper.casino777.box';
import {SwiperWrapperMrGreenBox} from './swiper-wrapper.mrgreen.box';

export const SwiperWrapperBox = styledByTheme(SwiperWrapperDefaultBox)
    .forCasino777(SwiperWrapperCasino777Box)
    .forMrGreen(SwiperWrapperMrGreenBox).apply();